var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaypointOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.893,
    height: 18.874,
    viewBox: "0 0 18.893 18.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-590.073 -288.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2438",
    d: "M425.5,183.694c-.038-.1-.46-1.607-.939-3.348l-.87-3.164-3.3-.917c-1.817-.506-3.293-.935-3.28-.955s1.5-.45,3.3-.955l3.28-.913.908-3.292c.5-1.811.929-3.292.955-3.292s.455,1.481.955,3.292l.908,3.292,3.275.912c1.8.5,3.275.934,3.275.959s-1.474.457-3.276.959l-3.276.912-.924,3.347C425.729,183.289,425.554,183.845,425.5,183.694Z",
    transform: "translate(174 123)",
    fill: "none",
    stroke: "#679ac9",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaypointOutline);
export default __webpack_public_path__ + "static/media/waypoint-outline.a129b1125167636035db1308e7a20666.svg";
export { ForwardRef as ReactComponent };